<template>
    <div v-click-outside="close" :class="{'picker-container': true, must: must, short: !title}">
        <label v-show="title" class="title">{{title}}</label>
        <div @click="showSelect = !showSelect" :style="'min-width:'+width+'px'" :class="{picker: true}">
            <span v-show="!selectedItem" class="placeholder">{{placeholder}}</span>
            <span v-show="selectedItem" class="item">{{selectedItem}}</span>
            <img :class="{arrow: true,rotate: showSelect}" src="@assets/img/common/down.png">
        </div>
        <ul v-show="showSelect" class="picker-list">
            <li @click="selectedItem = item.name;selectedItemId = item.id;showSelect = false" v-for="(item,index) in list" :key="index">{{item.name}}</li>
        </ul>
    </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            selectedItem: null,
            selectedItemId: null,
            showSelect: false
        }
    },
    methods: {
        close() {
            this.showSelect = false
        }
    },
    watch: {
        selectedItemId(to) {
            this.$emit('picker',to)
        },
        list(to){
            console.log(to)
            to.forEach(el => {
            if(el.selected){
                this.selectedItem = el.name
            }
        })
        }
    },
    props: {
        title: {
            type: String
        },
        must: {
            type: Boolean,
            default: true
        },
        width: {
            type: Number,
            default: 200
        },
        placeholder: {
            type: String
        },
        list: {
            type: Array,
            default: []
        }
    },
    created() {
        setTimeout(() => {
            // console.log(Array.isArray(this.list))
            if(Array.isArray(this.list) && this.list.length > 0){
                // console.log(this.list)
                this.list.forEach(el => {
                    if(el.selected){
                        this.selectedItem = el.name
                        console.log(this.selectedItem)
                    }
                })
            }
        }, 300);
    }
}
</script>
<style src="@assets/css/global.less" lang="less" scoped>
</style>
<style lang="less" scoped>
    .picker-container {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        // width: 100%;
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;

        &.short {
            padding-left: 10px;
            box-sizing: border-box;
        }

        &.must {
            padding-left: 0;
            &::before {
                content: "*";
                display: inline-block;
                width: 10px;
                height: 30px;
                font-size: 24px;
                color: #ff555a;
                margin-right: 10px;
                padding-top: 5px;
            }
        }

        .title {
            min-width: 56px;
            font-size: 14px;
            color: #829191;
            margin-right: 30px;
            text-align-last:justify;
            text-align:justify;
            text-justify:distribute-all-lines;

        }

        .picker {
            height: 30px;
            outline: none;
            padding: 0px 9px;
            background: none;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            vertical-align: middle;
            border: 1px solid #dcdcdc;
            border-radius: 4px;

            .placeholder {
                font-size: 14px;
                color: #BBBBBB;
            }

            .item {
                font-size: 14px;
                color: #050f0f;
            }

            .arrow {
                cursor: pointer;
                user-select: none;

                &.rotate {
                    transform: rotate(180deg);
                }
            }
        }

        .picker-list {
            position: absolute;
            left: 0;
            top: 30px;
            width: 100%;
            background-color: #fff;
            margin-top: 10px;
            border-radius: 4px;
            overflow: hidden;
            z-index: 9999999;
            box-shadow: 4px 4px 10px 0 rgba(5,10,15,0.05);
            max-height: 300px;
            overflow-y: auto;

            li {
                display: flex;
                line-height: 30px;
                padding: 10px 0px;
                padding-left: 20px;
                font-size: 14px;
                color: #050f0f;

                &:hover {
                    background: rgba(65, 180, 140, 0.15);
                }
            }
        }
    }
</style>